import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { RepairCostingInfosManagement } from '../components/RepairCostingInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TRepairCostingSchema,
  repairCostingSchema,
} from '@/schemas/repair-costing/repair-costing.schema';
import { useCreateRepairCosting } from '@/hooks/repair-costing.hooks';
import { useTranslation } from 'react-i18next';

export const CreateRepairCostingPage = () => {
  const { t } = useTranslation('repairCosting');
  const navigate = useNavigate();

  const {
    watch: watchRepairCosting,
    control: repairCostingControl,
    register: registerRepairCosting,
    setValue: setRepairCostingValue,
    setError: setRepairCostingError,
    handleSubmit: handleSubmitRepairCosting,
    formState: {
      errors: repairCostingErrors,
      isSubmitting: isSubmittingRepairCosting,
    },
  } = useForm<TRepairCostingSchema>({
    resolver: zodResolver(repairCostingSchema),
  });

  const {
    mutate: mutateCreateRepairCosting,
    isPending: isPendingCreateRepairCosting,
  } = useCreateRepairCosting({
    t,
    handleSuccess: () => navigate('/repair-costings'),
  });

  const onSubmitRepairCosting = (repairCosting: TRepairCostingSchema) => {
    mutateCreateRepairCosting(repairCosting);
  };

  return (
    <>
      <PageHeader
        backToLink="/repair-costings"
        title={t('addRepairCosting')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text={t('repairCostingList')}
              linkTo="/repair-costings"
            />
            <BreadcrumbItem text={t('addRepairCosting')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <RepairCostingInfosManagement<TRepairCostingSchema>
          t={t}
          watch={watchRepairCosting}
          control={repairCostingControl}
          register={registerRepairCosting}
          setValue={setRepairCostingValue}
          setError={setRepairCostingError}
          errors={repairCostingErrors}
          submitDisabled={
            isSubmittingRepairCosting || isPendingCreateRepairCosting
          }
          onSubmit={handleSubmitRepairCosting(onSubmitRepairCosting)}
        />
      </div>
    </>
  );
};
